import React, { Component } from 'react';
import $ from 'jquery'
import {
    Link, withRouter
} from 'react-router-dom';
import '../../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css'
// import '../../../node_modules/react-responsive-carousel/lib/styles/main.min.css'
import { Carousel } from 'react-responsive-carousel';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import carousel1 from '../../images/carousal1.png'
import carousel2 from '../../images/gm_cabdriver.jpg'
import carousel3 from '../../images/carousal3.jpg'
import carousel4 from '../../images/carousal4.jpg'


import services from '../../services/allservices.jsx'
import Signin from './signin.jsx'
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import CardNumber from './cardnumber.jsx'
import * as actions from '../../actions/actions.jsx'
import { connect } from 'react-redux';

import Loader from '../loader/loader.jsx'

const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
        managestate: state.Manage.managestate

    })

const mapDispatchToProps = dispatch =>
    ({
        fetchPublicKey(keyRecieved) {
            dispatch(
                actions.publicKeyAction(keyRecieved)
            )
        },
        fetchManageInform(managestate) {
            dispatch(
                actions.ManageAction(managestate)
            )
        }
    })

// const JSEncrypt = window.JSEncrypt
class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            dateofbirth: "",
            managestate: '',
            focus:false,
            autofocus: true
        };
        this.handleBlur = this.handleBlur.bind(this)
        this.onChange = this.onChange.bind(this)
        this.handleDate = this.handleDate.bind(this)
        this.handleSelect = this.handleSelect.bind(this)
    }
    componentDidMount() {
        this.props.fetchPublicKey(false)
        const tabs1= localStorage.setItem('landingTabs','cardNo')
        $(document).ready(function () {
            $("div.bhoechie-tab-menu>div.list-group>a").click(function (e) {
                e.preventDefault();
                $(this).siblings('a.active').removeClass("active");
                $(this).addClass("active");
                var index = $(this).index();
                $("div.bhoechie-tab>div.bhoechie-tab-content").removeClass("active");
                $("div.bhoechie-tab>div.bhoechie-tab-content").eq(index).addClass("active");
            });
        });
    }
    onSuggestSelect(suggest) {

    }
    changeToEditView(e) {
        this.setState({ addressComp: false })
    }
    handleBlur() {
        this.setState({ addressComp: true })
    }
    handleDate(e, date) {
        this.setState({
            dateofbirth: date.toString()
        })
    }
    handleSelect(event, index, value) {
        this.setState({
            gender: value
        })
    }
    onChange(e, value) {
        this.setState({
            [e.target.name]: value
        })

    }
    handleClick=()=>{
        localStorage.setItem('landingTabs','userName1')
        this.setState({
            landingTabs:'userName1',
            focus:true,


        })
    }
    handleRegister=()=>{
        const tabs1= localStorage.setItem('landingTabs','cardNo')
        this.setState({
            landingTabs:'cardNo'
        })
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.managestate=== true){
            let lo= document.getElementById("signin")
            lo.classList.add("active")

            let lo1=document.getElementById("signin1")
            lo1.classList.add("active")

            let cd= document.getElementById("cardno")
            cd.classList.remove("active")

            let cd1= document.getElementById("cardno1")
            cd1.classList.remove("active")
        }

        else{
            let lo= document.getElementById("signin")
            lo.classList.remove("active")

            let lo1=document.getElementById("signin1")
            lo1.classList.remove("active")

            let cd= document.getElementById("cardno")
            cd.classList.add("active")

            let cd1= document.getElementById("cardno1")
            cd1.classList.add("active")
        }
    }
    // setFocus=()=>{
    //     let _this=this
    //  setTimeout(function(){
    //     _this.setState({
    //          autofocus:true
    //      },()=>{
   
    //      })
    //  },1000)
       
    // }
    render() {
        const { loader} = this.state
        const {managestate}=this.props
    
        return (
            <div className="row" >
                <ToastContainer
                    draggablePercent={60}
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable={false}
                    pauseOnHover
                />
                <div className="col-sm-12">
                    <div className="row" >
                        <div className="col-md-6 card-images nopaddingleft" >
                            <Carousel autoPlay infiniteLoop showThumbs={false} showArrows={false}>
                                <div>
                                    <img src={carousel1} alt="Image1" />
                                    {/* <p className="legend">
                                        Legend
                                    </p> */}
                                </div>
                                <div>
                                    <img src={carousel2} alt="Image1" />
                                    {/* <p className="legend">
                                        Legend
                                    </p> */}
                                </div>
                                <div>
                                    <img src={carousel3} alt="Image1" />
                                    {/* <p className="legend">
                                        Legend
                                    </p> */}
                                </div>
                                <div>
                                    <img src={carousel4} alt="Image1" />
                                    {/* <p className="legend">
                                        Legend
                                    </p> */}
                                </div>
                            </Carousel>
                        </div>
                        <div className="col-md-6 regtabs" >
                            <div className="row" >
                                <div className="col-sm-12 bhoechie-tab-container">
                                    <div className="row" >
                                        <div className="col-lg-12 col-md-12 col-sm-12 bhoechie-tab-menu">
                                            <div className="list-group flex-row">
                                                <a className="col-md-6 list-group-item active text-center" id="cardno1" style={{ padding: "12px" }} onClick={this.handleRegister.bind(this)} >
                                                    <i className="fa fa-user-plus" aria-hidden="true" style={{ fontSize: 24, display: "block" }}></i>
                                                    <span>Activate / Register Your Card</span>
                                                </a>
                                                <a className="col-md-6 list-group-item text-center " id="signin1"  style={{ padding: "12px" }} onClick={this.handleClick.bind(this)} >
                                                    <i className="fa fa-sign-in" aria-hidden="true" style={{ fontSize: 24, display: "block" }}></i>
                                                    <span>Sign In To Your Card Account</span>
                                                </a>
                                                {/* <a href="#" className="col-md-4 list-group-item text-center" style={{padding:"6px"}}>
                                                    <h4><i className="fa fa-user-plus" aria-hidden="true"></i></h4>
                                                    <span>Sign Up</span>
                                                </a> */}

                                            </div>
                                        </div>

                                        <div className="col-lg-12 col-md-12 col-sm-12 bhoechie-tab" style={{ height: 300 }}>
                                            <div className="bhoechie-tab-content active " id="cardno">
                                                <CardNumber/>
                                            </div>

                                            <div className="bhoechie-tab-content " id="signin">
                                                {loader ? <div>
                                                    <Loader />
                                                </div> :
                                                    <Signin  focus={this.state.focus}/>}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Register));


// WEBPACK FOOTER //
// ./src/components/register/register.jsx